export default __webpack_public_path__ + "static/media/vessel_icon.1040e074.svg";